import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { Row, Col } from 'reactstrap';
import UploadImage from './UploadImage';
import UploadDocument from './UploadDocument';
import PersonalInfoForm from './PersonalInfoForm';

const PersonalInformation = forwardRef(({ applicationId, onSave, onNext, data, onDataChange,onParsedData  }, ref) => {
  const [formData, setFormData] = useState({
    image: null,
    document: null,
    personalInfo: {
      firstName: '',
      middleName: '',
      lastName: '',
      dateOfBirth: new Date(),
      gender: '',
      nationality: '',
      email: '',
      phone: '',
      mailingAddress: {
        address: '',
        city: '',
        state: '',
        country: '',
        zipCode: ''
      },
      useMailingAsPermanent: false,
      permanentAddress: {
        address: '',
        city: '',
        state: '',
        country: '',
        zipCode: ''
      }
    }
  });
  const [formData1, setFormData1] = useState({
    image: null,
    document: null,
    personalInfo: {
      firstName: '',
      middleName: '',
      lastName: '',
      dateOfBirth: new Date(),
      gender: '',
      nationality: '',
      email: '',
      phone: '',
      mailingAddress: {
        address: '',
        city: '',
        state: '',
        country: '',
        zipCode: ''
      },
      useMailingAsPermanent: false,
      permanentAddress: {
        address: '',
        city: '',
        state: '',
        country: '',
        zipCode: ''
      }
    }
  });


  // console.log("PersonalInformation initial data:", onParsedData);
  const [showValidation, setShowValidation] = useState(false);
  const personalInfoFormRef = useRef();

  // Load saved data when component mounts or data changes
  useEffect(() => {
    if (data) {
      setFormData(prev => ({
        ...prev,
        ...data
      }));
    }
  }, [data]);


  // Handler to receive parsed data from UploadDocument and merge into personalInfo
  const handleParsedData = (parsedFields) => {
    // Handle null case when CV is deleted
    if (!parsedFields) {
      if (onParsedData) {
        onParsedData(null);
      }
      return;
    }
    
    // Merge parsed fields into personalInfo, preserving existing values where appropriate
    setFormData1(prev => {
        const updatedPersonalInfo = {
            ...prev.personalInfo,
            ...parsedFields,
        };
      const updatedData = {
        // ...prev,
        personalInfo: updatedPersonalInfo.personalInfo,
      };

      onDataChange(updatedData);
      if (onParsedData) {
        onParsedData(parsedFields);
      }
      return updatedData;
    });
  };

  const handleImageUpload = (file) => {
    const updatedData = {
      ...formData,
      image: file
    };
    setFormData(updatedData);
    onDataChange(updatedData);
  };

  const handleDocumentUpload = (file) => {
    console.log('handleDocumentUpload called with:', file);
    const updatedData = {
      ...formData,
      document: file
    };
    setFormData(updatedData);
    onDataChange(updatedData);
    // const isDisabled = !isDocumentUploaded;
  };

  // console.log("PersonalInformation formData:", formData);

  const handlePersonalInfoChange = (personalInfo) => {
    console.log('handlePersonalInfoChange called with:', personalInfo);
    const updatedData = {
      ...formData,
      personalInfo
    };
    setFormData(updatedData);
    onDataChange(updatedData);
  };

  // Expose validate() to parent via ref
  useImperativeHandle(ref, () => ({
    validate: () => {
      setShowValidation(true);
      let valid = true;
      let imageMissing = !formData.image;
      let documentMissing = !formData.document;
      if (personalInfoFormRef.current && personalInfoFormRef.current.validate) {
        valid = personalInfoFormRef.current.validate();
      }
      if (imageMissing || documentMissing) {
        valid = false;
      }
      return valid;
    },
    clearValidation: () => setShowValidation(false)
  }));

  return (
    <>
      <Row>
        <Col xl="12">
          <h2 className="personalinfo_head">Personal Information</h2>
        </Col>
      </Row>

      <Row>
        <Col xl="2">
          <UploadImage
            onFileSelect={handleImageUpload}
            initialFile={formData.image}
          />
          {showValidation && !formData.image && (
            <div style={{ color: 'red', fontSize: 13, marginTop: 4 }}>Image is required.</div>
          )}
        </Col>

        <Col xl="10">
          <UploadDocument
            onFileSelect={handleDocumentUpload}
            initialFile={formData.document}
            onParsedData={handleParsedData}
          />
          {showValidation && !formData.document && (
            <div style={{ color: 'red', fontSize: 13, marginTop: 4 }}>CV is required.</div>
          )}
        </Col>
      </Row>

      <PersonalInfoForm
        ref={personalInfoFormRef}
        data={formData.personalInfo}
        onChange={handlePersonalInfoChange}
        showValidation={showValidation}
        isDocumentUploaded={!!formData.document}
      />
    </>
  );
});

export default PersonalInformation;
